import { QUERY_COLOR, QUERY_STORAGE } from '~/utils/pdp/queryParamHelpers';
import { usePdpCanonicalUrl } from './usePdpCanonicalUrl';

interface Props {
  productCategory: 'phone' | 'accessory';
}

export const usePdpSEOMetaOgData = (props: Props) => {
  const pdpStore = useMyProductPageStore();
  const route = useRoute();
  const canonicalUrl = usePdpCanonicalUrl();
  const routePathWatchable = computed(() => route.fullPath);

  const productSeoTitle = computed(() => {
    const urlHasVariantParams =
      routePathWatchable.value.includes(`${QUERY_COLOR}=`) ||
      routePathWatchable.value.includes(`${QUERY_STORAGE}=`);

    return urlHasVariantParams
      ? pdpStore.productSeoTitleAsProductVariant
      : pdpStore.productSeoTitleWithoutVariant;
  });

  const makeSeoInput = (productSeoTitle: string) => {
    const title =
      props.productCategory === 'phone'
        ? `Köp ${productSeoTitle} med abonnemang | Halebop.se`
        : `Köp ${productSeoTitle} | Halebop.se`;

    const desc =
      props.productCategory === 'phone'
        ? `Köp ${productSeoTitle} med abonnemang. Du får Telias supertäckning, den bästa i Sverige med ett stabilt 5G-nät, ✅ 24/7 kundsupport, ✅ och fri frakt! ✅ Lita på kundernas recensioner på Trustpilot! ✅`
        : `Köp ${productSeoTitle}.`;

    const seoInput = {
      seoData: {
        title: title,
        description: desc,
        image: pdpStore.productSeoImageUrl,
        siteName: 'Halebop',
        keywords: pdpStore.product?.Seo.Keywords,
        canonicalUrl,
      },
      fallBackSeoData: {
        title: title,
        description: desc,
        image: pdpStore.productSeoImageUrl,
        siteName: 'Halebop',
        canonicalUrl,
      },
    };

    return seoInput;
  };

  const seoInput = makeSeoInput(productSeoTitle.value);

  useCustomSeoMeta(seoInput);

  watch(productSeoTitle, (newProductSeoTitle, prevProductSeoTitle) => {
    if (newProductSeoTitle === prevProductSeoTitle) {
      return;
    }

    const seoInput = makeSeoInput(newProductSeoTitle);
    useCustomSeoMeta(seoInput);
  });
};
